import React from 'react'
import { useTheme } from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'
import FilterPill from '../FilterPill/FilterPill'
import {
  FilterSection,
  FilterGrid
} from '../MobileFiltersPanel/MobileFiltersPanel.styles'

const StandardFilterSection = ({
  title,
  options,
  filterType,
  localSelectedFilters,
  handleFilterToggle,
  handleSingleFilterToggle,
  sortFilterOptions,
  singleSelect = false,
  icon,
  children
}) => {
  const theme = useTheme()

  return (
    <FilterSection>
      <Tonality.UIText
        textStyle="bodyBold"
        style={{ fontSize: '16px' }}
        color={theme.colors.neutralW90}
      >
        {icon}
        {title}
      </Tonality.UIText>
      <FilterGrid>
        {sortFilterOptions(options, filterType).map((option) => {
          const isSelected = localSelectedFilters.some(
            (f) => f.type === filterType && f.id === option.id
          )

          // For single-select: disable other options if one is already selected
          const hasAnySelected =
            singleSelect &&
            localSelectedFilters.some((f) => f.type === filterType)
          const isDisabled = singleSelect && hasAnySelected && !isSelected

          const toggleHandler = singleSelect
            ? handleSingleFilterToggle(filterType, options)
            : handleFilterToggle(filterType, options)

          return (
            <FilterPill
              key={option.id}
              option={option}
              filterType={filterType}
              isSelected={isSelected}
              onToggle={toggleHandler}
              disabled={isDisabled}
            />
          )
        })}
        {children}
      </FilterGrid>
    </FilterSection>
  )
}

export default StandardFilterSection
